<template>
  <div>
    <div class="news">
      <div class="news-list">
        <b-card>
          <b-card-body>
            <div class="title">
              <div class="title-text"><h1>平台新闻</h1></div>
              <div class="title-link">
                <router-link to="/news/"><span>更多 &#187;</span></router-link>
              </div>
            </div>
            <b-list-group class="news-content">
              <b-list-group-item
                v-for="(item, index) in news"
                v-bind:key="index"
                class="d-flex justify-content-between align-items-center"
              >
                <router-link :to="'/news/detail/?id=' + item.id">
                  <span>{{ item.title }}</span>
                </router-link>
                <b-badge variant="light" pill>{{ item.date }}</b-badge>
              </b-list-group-item>
            </b-list-group>
          </b-card-body>
        </b-card>
      </div>
      <div class="images">
        <b-carousel
          id="carousel-fade"
          style="text-shadow: 0px 0px 2px #000"
          fade
          indicators
          controls
        >
          <b-carousel-slide
            v-for="(item, index) in images"
            v-bind:key="index"
            :caption="item.title"
          >
            <template slot="img">
              <img :src="item.image" />
            </template>
          </b-carousel-slide>
        </b-carousel>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data: function () {
    return {
      images: [],
      news: [],
    };
  },
  created: function () {
    this.get_images();
    this.get_latest_news();
  },
  methods: {
    get_images() {
      let url = "news/banners/?ordering=index";
      this.$http.get(url).then((response) => {
        this.images = response.data;
      });
    },
    get_latest_news: function () {
      let url = "news/list/?ordering=-date&p=1&page_size=5";
      this.$http.get(url).then((response) => {
        this.news = response.data.results;
      });
    },
  },
};
</script>
<style lang="scss" scoped>
h1 {
  color: #931b22 !important;
  font-size: 20px;
  font-weight: bold;
  padding: 10px;
}
a {
  color: #3e3e3e;
  :hover {
    color: #931b22 !important;
  }
}
.news {
  margin: 30px 0 0;
  padding: 0;
  overflow: hidden;
  background-color: #f5f6fa;
  .card {
    background-color: #f5f6fa;
    border: none;
    margin: 0;
    padding-top: 5px;
    padding-bottom: 0;
    hr {
      border-bottom: 1px dashed #e9ecef;
    }
    .card-body {
      margin: 0;
      padding-top: 0;
      padding-bottom: 0;
    }
  }
  .news-list {
    padding: 10px 0;
    margin: 0;
    width: 790px;
    height: 380px;
    float: left;
    .title {
      height: 50px;
      border-bottom: 4px #931b22 solid;
      .title-text {
        width: 500px;
        float: left;
      }
      .title-link {
        width: 100px;
        float: right;
        padding: 10px;
      }
    }
    .news-content {
      clear: both;
    }
    a {
      color: #3e3e3e !important;
      font-size: 16px;
      text-overflow: ellipsis;
      white-space: nowrap;
      overflow: hidden;
      display: block;
    }
    .list-group-item {
      background-color: #f5f6fa;
      border-top: none;
      border-left: none;
      border-right: none;
      margin-top: 10px;
    }
    .badge {
      margin-left: 20px;
      font-weight: normal;
      color: #9e9e9e;
      font-size: 14px;
    }
  }
  .images {
    width: 500px;
    height: 350px;
    margin: 20px 0;
    padding: 0;
    float: right;
    img {
      width: 500px;
      height: 350px;
    }
  }
}
</style>
